// extracted by mini-css-extract-plugin
export default {"color":"ForgotPassword_color__6Ml+q","options":"ForgotPassword_options__CCQ7G","link":"ForgotPassword_link__jGTAU"};